import { SOL_TIPO_DOCUMENTO } from '../conf/constants';

/** Ejemplo de uso
 * computed: {
    debounceNif: {
      get() {
        return this.model.persona.nif
      },
      set: debounce(function (value) {
        this.model.persona.nif = value;

        if(this.model.persona.nif && this.model.persona.nif.length == 9 && this.creationMode) {
          this.eventGetInfoFromNif(this.model.persona.nif);
        }
      }),
    },
  }
 */
/**
 * Debounce
 *
 * @param {Function} callback
 * @param {Number} delay
 * @returns {Function}
 */
export function debounce(callback, delay = 500) {
  let timeoutID;

  return (...args) => {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => callback(...args), delay);
  };
}

/* Recibe un response y lo transforma en un Blob.
- Util para descargar imagenes, pdf... del servidor.
EJ: En el componente // <vue-pdf :src="pdfData"></vue-pdf> \\ pdfData es este objeto directamente.

Stackoverflow: https://stackoverflow.com/questions/65255649/load-pdf-from-server-and-embed-in-vue-app
Mas docs de vue-pdf: https://www.npmjs.com/package/vue-pdf
*/
export function createBlobFromResponse(resp) {
  var blob = new Blob([resp.data], { type: resp.headers['content-type'] });
  const objectUrl = URL.createObjectURL(blob);
  return objectUrl;
}

/** Recibe un Byte[] y lo transforma en un Blob.
 * Source:https://stackoverflow.com/questions/38399544/is-there-any-way-to-convert-byte-array-to-blob-object-on-client-side-in-node-js
 */
export function createBlobFromByteArray(data) {
  var blob = new Blob([new Uint8Array(data)]);
  const objectUrl = URL.createObjectURL(blob);
  return objectUrl;
}

export function getFileExtension(mimeType = null) {
  let extension = 'documento';
  if (mimeType && mimeType.includes('image/') && !mimeType.includes('tif')) {
    extension = mimeType.split('/')[1];
  } else {
    switch (mimeType) {
      case 'application/msword':
        extension = '.doc';
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        extension = '.docx';
        break;
      case 'application/vnd.oasis.opendocument.text':
        extension = '.odt';
        break;
      case 'application/pdf':
        extension = '.pdf';
        break;
      case 'application/x-rar-compressed':
        extension = '.rar';
        break;
      case 'application/zip':
        extension = '.zip';
        break;
      case 'application/x-7z-compressed':
        extension = '.7z';
        break;
      case 'image/tiff':
        extension = '.tiff';
        break;
      default:
        break;
    }
  }
  return extension;
}

/* Recibe un response y lo descarga en el navegador.
- Util para descargar imagenes, pdf... del servidor.
*/
export function downloadDocument(response) {
  var link = document.createElement('a');

  var blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });

  link.href = window.URL.createObjectURL(blob);
  link.download = response.headers['x-file-name'];
  document.body.appendChild(link);
  link.click();

  setTimeout(function () {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(window.URL.createObjectURL(blob));
  }, 1000);
}

/**
 * Recibe un elementId y lo centra en el navegador.
 */
export function scrollIntoView(elementId) {
  try {
    const element = document.getElementById(elementId);
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } catch (exception) {
    console.error(exception);
  }
}

/**
 * Eliminamos la clase de todos los elementos y añadimos la clase al elemento seleccionado.
 *
 */
export function activeClass(elementId, cssClass = '') {
  try {
    removeClass(cssClass);
    //añadir css activo al elemento seleccionado
    const element = document.getElementById(elementId);
    element.classList.add(cssClass);
  } catch (exception) {
    console.error(exception);
  }
}

export function removeClass(cssClass = '') {
  try {
    //quitar css activo de todos los elementos
    const activeElements = document.getElementsByClassName(cssClass);
    for (let i = 0; i < activeElements.length; i++) {
      activeElements[i].classList.remove(cssClass);
    }
  } catch (exception) {
    console.error(exception);
  }
}

export function formatUnixToDate(unix) {
  const date = new Date(unix);
  return date.toLocaleDateString();
}

export function leftPad(string = null, finalLegth, padChar = '0') {
  if (string == null) return null;
  let pad = '';
  let numCeros = finalLegth - string.trim().length;
  for (let i = 0; i < numCeros; i++) {
    pad += padChar;
  }
  return pad + string;
}

//Gestión de rutas la realizar el login
export function routeNameAfterLogin(id_tipo_documento = null) {
  let routeName = 'descargar-documentacion';

  switch (id_tipo_documento) {
    case SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PROPOECATA_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.POECATA2_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_2_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.POECATA3_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_2_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PETECATA3_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_3_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.POECATA4_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PETECATA4_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_3_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_4_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.POECATA5_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PETECATA5_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_4_NOTIFICACION_ALEGACION:
    case SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA:
    case SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PROPOECATA_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE1_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE2_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.POECATA2_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE1_2_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.POECATA3_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE2_2_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PETECATA3_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE1_3_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.POECATA4_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PETECATA4_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE2_3_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE1_4_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.POECATA5_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PETECATA5_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECANE2_4_SOLICITUD_IBAN:
    case SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_NOTIFICACION:
    case SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
    case SOL_TIPO_DOCUMENTO.PECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PROPOECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.CATA_DANA_RESOLUCION_FAVORABLE_PROVISIONAL:
      routeName = 'notificaciones';
      break;
    case SOL_TIPO_DOCUMENTO.CATA_DANA_RESOLUCION_DESFAVORABLE_PROVISIONAL:
      routeName = 'notificaciones';
      break;

    case SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_SUBSANACION:
      routeName = 'subsanaciones';
      break;

    case SOL_TIPO_DOCUMENTO.PECATA_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_SUBSANACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;

    case SOL_TIPO_DOCUMENTO.PECATA_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_CONFIRMACION_IBAN:
      routeName = 'comprobar-iban';
      break;

    default:
      break;
  }

  return routeName;
}
// Gestión de rutas la realizar el login
// export function routeNameAfterLogin(id_tipo_documento = null) {
//   const routes = {
//     [SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'notificaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_SUBSANACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_SUBSANACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_SUBSANACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_SUBSANACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.POECATA_SUBSANACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.PETECATA_SUBSANACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.PECATA_CONFIRMACION_IBAN]: 'comprobar-iban',
//     [SOL_TIPO_DOCUMENTO.POECATA_CONFIRMACION_IBAN]: 'comprobar-iban',
//     [SOL_TIPO_DOCUMENTO.PETECATA_CONFIRMACION_IBAN]: 'comprobar-iban',
//   };

//   return routes[id_tipo_documento] || 'notificaciones'; // Valor predeterminado
// }

// Gestión de rutas posterior a la firma de una notificación
export function routeNameAfterSignNotificaction(id_tipo_documento = null) {
  let routeName = 'descargar-documentacion';

  switch (id_tipo_documento) {
    case SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA:
    case SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
    case SOL_TIPO_DOCUMENTO.PECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PROPOECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE1_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.POECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PETECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
    case SOL_TIPO_DOCUMENTO.PECANE2_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.CATA_DANA_RESOLUCION_FAVORABLE_PROVISIONAL:
      routeName = 'descargar-documentacion';
      break;
    case SOL_TIPO_DOCUMENTO.CATA_DANA_RESOLUCION_DESFAVORABLE_PROVISIONAL:
      routeName = 'descargar-documentacion';
      break;

    case SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_NOTIFICACION:
      routeName = 'subsanaciones';
      break;
    case SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_NOTIFICACION_ALEGACION:
      routeName = 'documentos-alegacion';
      break;

    //IBAN
    case SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PROPOECATA_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA2_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_2_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA3_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_2_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA3_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_3_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA4_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA4_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_3_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE1_4_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.POECATA5_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PETECATA5_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;
    case SOL_TIPO_DOCUMENTO.PECANE2_4_SOLICITUD_IBAN:
      routeName = 'comprobar-iban';
      break;

    default:
      break;
  }

  return routeName;
}
// Gestión de rutas posterior a la firma de una notificación
// export function routeNameAfterSignNotificaction(id_tipo_documento = null) {
//   const routes = {
//     [SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA]: 'descargar-documentacion',
//     [SOL_TIPO_DOCUMENTO.PECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'descargar-documentacion',
//     [SOL_TIPO_DOCUMENTO.POECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'descargar-documentacion',
//     [SOL_TIPO_DOCUMENTO.PETECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL]: 'descargar-documentacion',
//     [SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION]: 'subsanaciones',
//     [SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION]: 'documentos-alegacion',
//     [SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN]: 'comprobar-iban',
//     [SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN]: 'comprobar-iban',
//     [SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN]: 'comprobar-iban',
//   };

//   return routes[id_tipo_documento] || 'descargar-documentacion';
// }

export function hasNotificationNextStep(id_tipo_documento = null) {
  const notificationWithSteps = [
    SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE1_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE1_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PROPOECATA_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PROPOECATA_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.POECATA2_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.POECATA2_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE2_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE2_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE1_2_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE1_2_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.POECATA3_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.POECATA3_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE2_2_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE2_2_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PETECATA3_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PETECATA3_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE1_3_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE1_3_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.POECATA4_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.POECATA4_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PETECATA4_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PETECATA4_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE2_3_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE2_3_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE1_4_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE1_4_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.POECATA5_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.POECATA5_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PETECATA5_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PETECATA5_SOLICITUD_IBAN,

    SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_NOTIFICACION,
    SOL_TIPO_DOCUMENTO.PECANE2_4_NOTIFICACION_ALEGACION,
    SOL_TIPO_DOCUMENTO.PECANE2_4_SOLICITUD_IBAN,

  ];

  return notificationWithSteps.includes(id_tipo_documento);
}
